const URL = window.URL || window.webkitURL;

// 创建一个DOMString， 其中包含一个表示参数中给出的对象的URL。
export const createObjectURL = window.createObjectURL || URL.createObjectURL.bind(URL);

// 释放之前通过URL.createObjectURL创建的已存在的URL对象。虽然在浏览器被关闭时，URL对象也会被回收，但是为了
// 减少资源的浪费，应该在不需要该URL对象后直接使用该方法释放URL对象。
export const revokeObjectURL = window.revokeObjectURL || URL.revokeObjectURL.bind(URL);
